export default "__VITE_ASSET__9e9f945f__"